import React from "react";
export default React.createContext({
    isAuthenticated: false,
    user: {
        firstName: "",
        lastName: "",
        username: "",
        city: "",
        country: "",
        email: "",
        mobilePhone: "",
        streetAddress: "",
        zipCode: "",
        additionalCustomerIds: [],
        birthdate: "",
        careOf: "",
        companyName: "",
        countryCode: "",
        language: "",
        orgNo: "",
        vatNo: "",
        gtmId: "",
    },
    login: () => { },
    logout: () => { },
    getConsumer: () => { },
    loadingAuth: true,
});
